import { render, staticRenderFns } from "./SayfaAyarlar.vue?vue&type=template&id=caff6038&scoped=true"
import script from "./SayfaAyarlar.vue?vue&type=script&lang=js"
export * from "./SayfaAyarlar.vue?vue&type=script&lang=js"
import style0 from "./SayfaAyarlar.vue?vue&type=style&index=0&id=caff6038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caff6038",
  null
  
)

export default component.exports